import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { WindowService } from '../../services/window.service'
import { TranslationService } from '../../services/translation.service'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-footer',
  imports: [MatToolbarModule, RouterModule],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  windowService = inject(WindowService)
  translationService = inject(TranslationService)
  isMobileView: boolean = false

  async ngOnInit(): Promise<void> {
    this.windowService.isMobileView$.subscribe((isMobileView: boolean) => {
      this.isMobileView = isMobileView
    })
  }
}
